import { render, staticRenderFns } from "./InfoHeader.vue?vue&type=template&id=75a24556"
import script from "./InfoHeader.vue?vue&type=script&lang=js"
export * from "./InfoHeader.vue?vue&type=script&lang=js"
import style0 from "./InfoHeader.vue?vue&type=style&index=0&id=75a24556&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports